import fp from "lodash/fp";

import { withResetState } from "store/hocs";

import { rolesConstants } from "./roles.constants";

const initialState = {
	loading: false,
	error: null,
	allowedRoles: [],
};

export const getRolesState = state => state.roles;

//prettier-ignore
const selector = property =>
	fp.flow(getRolesState, fp.property(property));

export const getAllowedRoles = selector("allowedRoles");

function roles(state = initialState, action) {
	switch (action.type) {
		case rolesConstants.GET_ROLES_REQUEST:
			return {
				...state,
				loading: true,
			};
		case rolesConstants.GET_ROLES_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				allowedRoles: action.allowedRoles,
			};
		case rolesConstants.GET_ROLES_FAILURE:
			return {
				...state,
				loading: false,
				error: action.error,
			};
		default:
			return state;
	}
}
export default withResetState({ initialState })(roles);
